import styled from "styled-components";

export const Wrapper = styled.svg`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;
